// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/city_geo.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { CityGeoService } from "./city_geo_pb";

/**
 * GetCityRegions returns a GeoJSON FeatureCollection of every city's outline
 * (bbox rectangle) as a JSON string.
 *
 * @generated from rpc travplaces.v1.CityGeoService.GetCityRegions
 */
export const getCityRegions = CityGeoService.method.getCityRegions;

/**
 * CitiesOnRoute returns the cities a straight corridor between two endpoints
 * crosses (point-in-bbox on either endpoint).
 *
 * @generated from rpc travplaces.v1.CityGeoService.CitiesOnRoute
 */
export const citiesOnRoute = CityGeoService.method.citiesOnRoute;
